import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconX } from "@tabler/icons-react";
import { StaticDatePicker, LocalizationProvider, YearCalendar } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { CommonUtils } from "utils";
import { vi } from "date-fns/locale";
import { LangConstant } from "const";
import dayjs from "dayjs";

const SelectDateTime = ({ open, setSinceTime, setLastTime, setLabel, onClose }) => {
  const { t: getLabel } = useTranslation();

  const [isOpenYearPicker, setIsOpenYearPicker] = useState(false);
  const [isOpenDatePicker, setIsOpenDatePicker] = useState(false);
  const [tmpSinceTime, setTmpSinceTime] = useState("");
  const [tmpLastTime, setTmpLastTime] = useState("");

  const options = [
    { id: 0, label: getLabel(LangConstant.TXT_DATE_TODAY) },
    { id: 1, label: getLabel(LangConstant.TXT_DATE_LAST_7_DAYS) },
    { id: 2, label: getLabel(LangConstant.TXT_DATE_LAST_1_MONTH) },
    { id: 3, label: getLabel(LangConstant.TXT_DATE_LAST_3_MONTHS) },
    { id: 4, label: getLabel(LangConstant.TXT_DATE_BY_YEAR) },
    { id: 5, label: getLabel(LangConstant.TXT_DATE_CUSTOM) },
  ];

  const onChangeOptions = item => {
    switch (item.id) {
      case 0: {
        setIsOpenYearPicker(false);
        setIsOpenDatePicker(false);
        setSinceTime(CommonUtils.getStartToday());
        setLastTime(null);
        setLabelSelectDateTime(item.label);
        break;
      }
      case 1: {
        setIsOpenYearPicker(false);
        setIsOpenDatePicker(false);
        setSinceTime(CommonUtils.getStartToday() - 7 * 86400000);
        setLastTime(null);
        setLabelSelectDateTime(item.label);
        break;
      }
      case 2: {
        setIsOpenYearPicker(false);
        setIsOpenDatePicker(false);
        setSinceTime(CommonUtils.getStartToday() - 30 * 86400000);
        setLastTime(null);
        setLabelSelectDateTime(item.label);
        break;
      }
      case 3: {
        setIsOpenYearPicker(false);
        setIsOpenDatePicker(false);
        setSinceTime(CommonUtils.getStartToday() - 3 * 30 * 86400000);
        setLastTime(null);
        setLabelSelectDateTime(item.label);
        break;
      }
      case 4: {
        setIsOpenYearPicker(true);
        setIsOpenDatePicker(false);
        break;
      }
      case 5: {
        setIsOpenYearPicker(false);
        setIsOpenDatePicker(true);
        break;
      }
      default: {
        break;
      }
    }
  };

  const setLabelSelectDateTime = label => {
    setLabel(label);
    if (label !== getLabel(LangConstant.TXT_DATE_CUSTOM)) {
      setTmpSinceTime("");
      setTmpLastTime("");
    }
    onClose();
  };

  const onChangeYear = e => {
    setSinceTime(e.getTime());
    setLastTime(e.getTime() + 365 * 86400000);
    setLabelSelectDateTime(e.getFullYear());
  };

  const onConfirmDateTime = () => {
    setSinceTime(tmpSinceTime.getTime());
    setLastTime(tmpLastTime.getTime());
    setLabelSelectDateTime(
      dayjs(tmpSinceTime.getTime()).format("DD/MM/YYYY") + " - " + dayjs(tmpLastTime.getTime()).format("DD/MM/YYYY"),
    );
  };

  useEffect(() => {
    setIsOpenYearPicker(false);
    setIsOpenDatePicker(false);
  }, [open]);

  const YearComponent = () => {
    return (
      <div className="card shadow-sm">
        <div className="d-flex align-items-center justify-content-end border-bottom px-3" style={{ height: "30px" }}>
          <IconX
            size={16}
            className="cursor-pointer"
            style={{ cursor: "pointer" }}
            onClick={() => setIsOpenYearPicker(false)}
          />
        </div>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <YearCalendar orientation="landscape" disableFuture onChange={onChangeYear} />
        </LocalizationProvider>
      </div>
    );
  };

  const DateComponent = () => {
    return (
      <div className="card shadow-sm">
        <div className="card-body p-0">
          <div className="d-flex">
            <LocalizationProvider adapterLocale={vi} dateAdapter={AdapterDateFns}>
              <StaticDatePicker
                disableFuture
                slotProps={{ actionBar: { actions: [] } }}
                value={tmpSinceTime}
                onChange={e => setTmpSinceTime(e)}
              />
              <StaticDatePicker
                disableFuture
                slotProps={{ actionBar: { actions: [] } }}
                value={tmpLastTime}
                onChange={e => setTmpLastTime(e)}
              />
            </LocalizationProvider>
          </div>
          <div className="d-flex justify-content-end gap-2 p-3">
            <button className="btn btn-danger" onClick={() => setIsOpenDatePicker(false)}>
              {getLabel(LangConstant.L_CANCEL)}
            </button>
            <button
              className="btn btn-primary"
              onClick={onConfirmDateTime}
              disabled={!Boolean(tmpSinceTime) || !Boolean(tmpLastTime)}
            >
              {getLabel(LangConstant.L_CONFIRM_BUTTON)}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {open ? (
        <div className="d-flex flex-row-reverse gap-3">
          <div className="card shadow-sm mb-0" style={{ width: "200px", zIndex: 4 }}>
            <div className="list-group list-group-flush" style={{ maxHeight: "160px", overflow: "auto" }}>
              {options.map(item => (
                <button
                  key={item.id}
                  className="list-group-item list-group-item-action"
                  onClick={() => onChangeOptions(item)}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {isOpenYearPicker && <YearComponent />}
          {isOpenDatePicker && <DateComponent />}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default SelectDateTime;
